import { Button, Grid, TextField } from '@material-ui/core'
import { Formik, Form } from 'formik'
import React, { FC, useState } from 'react'
import { cpfMask } from '../../../../../cross-cutting/masks/cpf'
import { useI18n } from 'utils/i18n/hooks/useI18n'

interface FormCpfProps {
    onSubmit: (cpf: string) => void
}
export const FormCpf: FC<FormCpfProps> = ({ onSubmit }) => {
    const [formObject, setformObject] = useState<{ cpf: string }>({} as { cpf: string })
    const { t } = useI18n();

    const onsubmit = () => {
        onSubmit(formObject.cpf);
    }


    const onChangeCpf = (cpf: string) => {
        setformObject(prev => ({ cpf: cpfMask(cpf) }))
    }


    return (
        <Formik
            initialValues={formObject}
            onSubmit={onsubmit}
        >{
                ({
                    handleSubmit,
                    handleChange,
                    values,
                    isValid,
                    errors,
                    touched
                }) =>
                    <Form onSubmit={handleSubmit}>
                        {
                            <Grid container spacing={1} >
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        variant="outlined"
                                        fullWidth
                                        name="cpf"
                                        value={formObject.cpf}
                                        onChange={(e) => onChangeCpf(e.target.value)}
                                        label={t("auth.cpf.label")}
                                        inputProps={{
                                            type: "tel",
                                        }}
                                    >

                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <Button

                                        fullWidth size="large"
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        {t("auth.cpf.register")}
                                        </Button>
                                </Grid>
                            </Grid>
                        }
                    </Form>
            }
        </Formik>
    )
}
